import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const mcwSchedule = lazy(() => import('../../container/mcw-schedule'));

const MCWSchedule = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/mcwSchedule`} component={mcwSchedule}/>
        </Switch>
    );
};

export default MCWSchedule;